let loggingEnabled = true;

export const setLoggingEnabled = (enabled: boolean) => {
    loggingEnabled = enabled;
};

export const isLoggingEnabled = () => loggingEnabled;

const makeLog = (fn: (...args: unknown[]) => void) => {
    return (...args: unknown[]) => {
        if (loggingEnabled) {
            fn(...args);
        }
    };
};

export const log = makeLog(console.log);
export const info = makeLog(console.info);
export const warn = makeLog(console.warn);
export const table = (...args: Parameters<typeof console.table>) => {
    if (loggingEnabled && typeof console.table === 'function') {
        console.table(...args);
    }
};
